export interface Agent {
    x: number;
    y: number;
    pose: string;
    flipX: boolean;
}

export interface RiderView {
    x: number;
    y: number;
    vx: number;
    vy: number;
    bellRung: boolean;
}

export const distance = (a: { x: number; y: number }, b: { x: number; y: number }) => Math.hypot(a.x - b.x, a.y - b.y);

export function moveToward<T extends Agent>(agent: T, tx: number, ty: number, speed: number, dt: number): T {
    const d = Math.hypot(tx - agent.x, ty - agent.y);
    if (d < 1e-6) return agent;
    const step = Math.min(d, speed * dt);
    const dx = ((tx - agent.x) / d) * step;
    return { ...agent, x: agent.x + dx, y: agent.y + ((ty - agent.y) / d) * step, flipX: dx > 0 };
}

export const runFrame = (time: number, rate: number, a: string, b: string) => (Math.floor(time * rate) % 2 ? b : a);

export const isApproaching = (agent: Agent, rider: RiderView) => rider.y < agent.y && rider.vy > 0;
